
import React, { Fragment, useState } from 'react'
import {AppButton,AppRow,AppGridBar,AppForm,AppGridTabs, AppTable,AppAction} from 'qcc'
import { Row, Icon ,Col} from 'antd';
import api, {CnarrayOutput,OrderInputT} from 'api';
import {PosApiInputBar} from '../components/PosApiInputBar'
import {PosApiInputContent} from '../components/PosApiInputContent'

let inputConfig = {
    example : {tel1: '',
        type: '2',
        zjnum: '',
        zprojectno: '',
    } as OrderInputT,
    formdata:{type:'2'},
    labelWidth:100 ,
    items:
    [
        {lable:'项目',field:'zprojectno',placeholder:'string类型:SAP项目P码'},
        {lable:'证件号码',field:'zjnum',placeholder:'string类型:证件号码'},
        {lable:'电话号码',field:'tel1',placeholder:'string类型:电话号码'},
        {lable:'参数对象',field:'type',itemType:'label' }
    ]
};
let outputExample = [
    {
        order:{
            db_KEY:'单据表主键',
            transacactionID:'交易主线ID',
            vbeln:'销售凭证',
            auart:'销售凭证类型',
            actual_NUMBER:'项目排号',
            aofy:'房源',
            aofyname:'房源描述',
            aold:'楼栋',
            paper_VBELN:'纸质单号',
            busks:'公司代码',
            zsm:'税码',
            zsl:'税率',
            ifbg:'是否有变更业务',
            },
            ysList:[
                {
                    DB_KEY:"计划表主键",
                    TransacactionID:"交易主线ID",
                    RCID1:"认筹单ID",
                    SEQ_NUM:"序号",
                    SKJH_NUM:"收款计划号",
                    AOXM:"项目",
                    AOFY:"房源",
                    AOFYName:"房源名称",
                    ZSZDY:"房间单元名",
                    PONUM:"房间房号",
                    ORDER_TYPE:"收款类型",
                    FUND_TYPE:"款项类型",
                    FUND_CODE:"款项编码",
                    YSRQ:"应收日期",
                    FUND_AMOUNT:"应收金额",
                    FUND_ACTUAL:"实收金额",
                    YGZNJ:"预估滞纳金金额"
                }
            ],
            khList:[
                {
                    PARENT_KEY:"单据表主键",
                    CUSTNUM:"客户编码",
                    CUST_NAME:"客户名称",
                    TEL1:"联系号码",
                    Number:"显示顺序",
                    ZJ_NUM:"证件号码",
                    ZJ_TYPE:"证件类型",
                }
            ],

    }
 ]

export const SapGetTrade = () =>{

    const[outputResult,setOutputResult]  = useState([] as CnarrayOutput[])
    const[outputView,setOutputView]  = useState(0)

    const execApi = async () =>{
        let inputParam = refPosApiInputContent.current.getFormData();
        AppAction.coverFull();
        let res = await api.public.possap.getOrderList(inputParam);
        setOutputResult(res);
        AppAction.cancelCoverFull();
    }

    const renderOutput = () =>{
        console.log('outputResult:',outputResult)
        if(outputResult===null) return '';

        switch(outputView){
            case 0:
            return <RoomTable list={outputResult}/>;
        }

        return  <pre>{JSON.stringify(outputResult, null, 4)}</pre>;
    }
    
    let refPosApiInputContent = React.createRef<PosApiInputContent>();
    return (<div className='app-demo-content'>
            <h1>SAP获取获取收款单/认筹单/签约(交易单)</h1>    
            <div>
                1、调用SAP接口获取SAP客户信息<br/>
                2、应用场景为POSAPP暂收款前确定客户ID <br/>
            </div>

            <div className='app-pos-api-input'>
                <PosApiInputBar  fn={execApi}/>
                <div className='app-pos-api-input-line'/>
                <PosApiInputContent ref={refPosApiInputContent} config={inputConfig} />
            </div>

            <div className='app-pos-api-input'>
                <AppGridBar>
                    <AppGridBar.Left>
                        <AppGridTabs defaultTabIndex={outputView} 
                        onChange={(tabIndex)=>{setOutputView(tabIndex)}} 
                        tabs={['列表','JSON']}/>
                    </AppGridBar.Left>
                </AppGridBar>
                <div className='app-pos-api-input-line'/>
                <Row className='app-pos-api-input-content'>
                    <Col span={16} className='app-pos-api-input-form'>
                        {renderOutput()}
                    </Col>
                    <Col span={8} className='app-pos-api-input-example'>
                        <div>示例：</div>
                        <pre>{JSON.stringify(outputExample, null, 4)}</pre>
                    </Col>
                </Row>

            </div>
    </div>)
}




const RoomTable = (props:{list:any[]}) =>{


    const seeYsList = (ysList:any[]) =>{
       let ystable =  <YsTable list={ysList} />

       AppAction.openDialog(ystable,{title:'应收明细',height:500,width:900});
    }

    const seeKhList = (khList:any[]) =>{
        let khTable =  <KhTable list={khList} />
 
        AppAction.openDialog(khTable,{title:'客户明细',height:500,width:900});
     }

    return ( <AppTable  dataSource={props.list} rightFixIndex={12}>
        <AppTable.ColIndex />
        <AppTable.Col field='db_KEY' title='单据表主键'  width={100}/>
        <AppTable.Col field='transacactionID' title='交易主线ID' width={100}/>
        <AppTable.Col field='vbeln' title='销售凭证' width={100}/>
        <AppTable.Col field='auart' title='销售凭证类型' width={100}/>
        <AppTable.Col field='actual_NUMBER' title='项目排号'  width={100}/>
        <AppTable.Col field='aofy' title='房源'  width={100}/>
        <AppTable.Col field='aold' title='楼栋'  width={100}/>
        <AppTable.Col field='paper_VBELN' title='纸质单号'  width={100}/>
        <AppTable.Col field='busks' title='公司代码'  width={100}/>
        <AppTable.Col field='zsm' title='税码'  width={100}/>
        <AppTable.Col field='zsl' title='税率'  width={100}/>
        <AppTable.Col field='ifbg' title='是否有变更业务'  width={100}/>

         <AppTable.Col title="应收明细" render={(data:any)=>{
             return <span 
             onClick = {()=>seeYsList(data.ysList)}
             style={{color:'blue',
             cursor:'pointer',
             textDecoration:'underline'}}>
             {data.ysList.length}
             </span>
         }}
          />
          <AppTable.Col title="客户明细" render={(data:any)=>{
             return <span 
             onClick = {()=>seeKhList(data.khList)}
             style={{color:'blue',cursor:'pointer',textDecoration:'underline'}}>
             {data.khList.length}
             </span>
         }}
          />
     </AppTable>)
}



const YsTable = (props:{list:any[]}) =>{
    return ( <AppTable  dataSource={props.list}>
        <AppTable.ColIndex />
            <AppTable.Col field='db_KEY' title='计划表主键'  width={100}/>
            <AppTable.Col field='transacactionID' title='交易主线ID'  width={100}/>
            <AppTable.Col field='rcid1' title='认筹单ID'  width={100}/>
            <AppTable.Col field='seq_NUM' title='序号'  width={100}/>
            <AppTable.Col field='skjh_NUM' title='收款计划号'  width={100}/>
            <AppTable.Col field='aoxm' title='项目'  width={100}/>
            <AppTable.Col field='aofy' title='房源'  width={100}/>
            <AppTable.Col field='aofyname' title='房源名称'  width={100}/>
            <AppTable.Col field='zszdy' title='房间单元名'  width={100}/>
            <AppTable.Col field='ponum' title='房间房号'  width={100}/>
            <AppTable.Col field='order_TYPE' title='收款类型'  width={100}/>
            <AppTable.Col field='fund_TYPE' title='款项类型'  width={100}/>
            <AppTable.Col field='fund_CODE' title='款项编码'  width={100}/>
            <AppTable.Col field='ysrq' title='应收日期'  width={100}/>
            <AppTable.Col field='fund_AMOUNT' title='应收金额'  width={100}/>
            <AppTable.Col field='fund_ACTUAL' title='实收金额'  width={100}/>
            <AppTable.Col field='ygznj' title='预估滞纳金金额'  width={100}/>
     </AppTable>)
}


const KhTable = (props:{list:any[]}) =>{
    return ( <AppTable  dataSource={props.list}>
        <AppTable.ColIndex />
        <AppTable.Col field='parent_KEY' title='单据表主键'  width={100}/>
<AppTable.Col field='custnum' title='客户编码'  width={100}/>
<AppTable.Col field='cust_NAME' title='客户名称'  width={100}/>
<AppTable.Col field='tel1' title='联系号码'  width={100}/>
<AppTable.Col field='number' title='显示顺序'  width={100}/>
<AppTable.Col field='zj_NUM' title='证件号码'  width={100}/>
<AppTable.Col field='zj_TYPE' title='证件类型'  width={100}/>
     </AppTable>)
}




// WEBPACK FOOTER //
// ./src/posapi/sap/SapGetTrade.tsx